import formsBackendClient from '@/tsClient/servers/noodleQuestionnaires';
import { type UpdateDynamicPdfTemplateRequest } from '@/typings/questionnaires-api-models';

const updateDynamicPdfTemplate = async (id: string, data: UpdateDynamicPdfTemplateRequest): Promise<void> => {
  const response = await formsBackendClient.put(`/dynamic-pdf-templates/${id}`, data);
  return response.data;
};

export default updateDynamicPdfTemplate;
